export enum QuestionType {
  Unknown = 0x0,
  FirstName = 0x1,
  LastName = 0x2,
  NPI = 0x4,
  SSNLast4Digits = 0x8,
  DOB = 0x10,
}
